module.exports = __webpack_public_path__ + "img/doc-ad2-lg.3f055446.jpg";